
export const delay = (ms: number): Promise<any> => {
    return new Promise((resolve: TimerHandler) => setTimeout(resolve, ms));
};
